module.exports = __webpack_public_path__ + "img/public/SiteIcons/hostStepIcons/pricing.svg?6a92dfa9";